import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Slider from '@mui/material/Slider';
import PopoverMenu from './PopoverMenu';
import ProTip from './ProTip';
import Promotion from './pages/promotion';
import NavHeader from './pages/NavHeader';
import { Box } from '@mui/material';
import ErrorBoundary from './ErrorBoundary';
function Copyright() {
  return (
    <Typography
      variant="body2"
      align="center"
      sx={{
        color: 'text.secondary',
      }}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Box>
        <NavHeader />
        <div className='h-[56px]'></div>
        <Promotion />
      </Box>
    </ErrorBoundary>

  );
}
